<template>
  <modal :show="show" @close="$emit('close')">
    <v-flex class="ma-1" slot="title">Potwierdź odbiór karty</v-flex>

    <div>
      <v-layout column>
        <v-flex xs12>
          <datepicker :schema="$schema.collectDate" />
        </v-flex>

        <v-btn color="success" flat @click="printConfirm">Wydrukuj potwierdzenie</v-btn>
      </v-layout>
    </div>

    <div v-show="false">
      <collection-confirm ref="confirmHTML" :profile="profile" :card="card" />
    </div>

    <v-layout slot="actions">
      <v-spacer />

      <v-btn color="error" flat @click="$emit('close')">Anuluj</v-btn>

      <v-btn color="success" flat @click="save">Zatwierdź</v-btn>
    </v-layout>
  </modal>
</template>

<script>
import { schemaMixin, WSchema } from '@witkac/vuetify-components';
import moment from 'moment';
import { mapState } from 'vuex';

import Modal from '@/components/material/Modal';
import CollectionConfirm from '@/components/printable/CollectionConfirm';
import { manageMixin } from '@/mixins/manage';
import { notificationsMixin } from '@/mixins/notifications';
import schema from '@/schemas/cardCollect.schema';

function emptyData() {
  return {
    collectionDate: ''
  };
}
// @vuese
// Modal odbioru karty klienta
// @group Client
export default {
  schema,
  mixins: [manageMixin(undefined, {}, emptyData), notificationsMixin],
  props: {
    // Identyfikator karty
    cardId: {
      type: Number,
      required: false
    }
  },
  methods: {
    // @vuese
    // Emituje event do zapisu danych
    add() {
      this.$emit('save', { ...this.model, id: this.cardId });
    },
    // @vuese
    // Przejście do wydruku potwierdzenia
    printConfirm() {
      const ref = this.$refs.confirmHTML.$el;
      const newWindow = window.open();
      newWindow.document.body.appendChild(ref);
    }
  },
  computed: {
    ...mapState({
      card(state) {
        return state.client.cards.list.find(card => card.id === this.cardId);
      },
      profile: state => state.client.data.profile
    })
  },
  components: { WSchema, Modal, CollectionConfirm }
};
</script>
